<script setup>
import { computed } from "vue";

const props = defineProps({
    progress: {
        type: Number,
        default: 0,
    },
    stage: {
        type: String,
        default: "bootstrap",
    },
    isFirstVisit: {
        type: Boolean,
        default: false,
    },
});

const stageMessageMap = {
    bootstrap: "تهيئة البيانات لأول زيارة...",
    versionCheck: "نتأكد من آخر تحديث للمنتجات...",
    catalogFetch: "تحميل المنتجات الأساسية...",
    applyData: "ترتيب المنتجات لعرضها بسرعة...",
    imageEnhance: "تجهيز الصور وتحسين الجودة...",
    done: "اكتمل التحميل",
};

const normalizedProgress = computed(() => {
    const n = Number(props.progress || 0);
    return Math.min(100, Math.max(0, Math.round(n)));
});

const stageMessage = computed(() => {
    return stageMessageMap[props.stage] || "جاري تجهيز الصفحة...";
});
</script>

<template>
    <div class="w-full max-w-2xl mx-auto rounded-xl border border-gray-200 bg-white/95 p-4 shadow-sm">
        <div class="flex items-center justify-between mb-2">
            <p class="text-sm font-medium text-tazej-gray-500">{{ stageMessage }}</p>
            <span class="text-sm font-semibold text-tazej-green-primary">{{ normalizedProgress }}%</span>
        </div>
        <div class="w-full h-2 rounded-full bg-gray-200 overflow-hidden">
            <div
                class="h-full bg-tazej-green-primary transition-all duration-500 ease-out"
                :style="{ width: `${normalizedProgress}%` }"
            />
        </div>
        <p v-if="isFirstVisit" class="mt-3 text-xs text-tazej-gray-500">
            التحميل الكامل يكون غالبا أول مرة فقط، وبعدها يصبح التصفح أسرع.
        </p>
    </div>
</template>
